import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ReferenceSkeletonCard() {
  return (
    <div className={cn('animate-pulse', 'col-span-1 w-full overflow-hidden rounded-[16px]')}>
      <div className="h-[204px] w-full bg-slate-50 sm:h-[240px]" />
      <div className="h-[179px] w-full bg-white sm:h-[198px]" />
    </div>
  );
}
